import { useQuery } from "@tanstack/react-query";

import { apiClient } from "app/modules/api-client";

export const useBrandedKeywords = (domain: string, countries: number[]) => {
    return useQuery({
        queryKey: ["branded-keywords", domain, countries],
        queryFn: () =>
            apiClient.MonitorAndProtectMaster.monitorandprotectBrandedkeywordsCreate({
                domain,
                countries,
            }),
        enabled: false,
        select: (response) => response.keywords,
    });
};
